import Vue from 'vue';
export default Vue.extend({
    name: 'massSellConfirmSpotPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    computed: {
        totalUSDT() {
            const totalSum = this.slotData.items.reduce((acc, item) => {
                return acc + parseFloat(item.valInUSDT);
            }, 0);
            return String(totalSum);
        }
    }
});
